import { FC, useContext, useEffect, useRef } from "react";
import { SocketContext, TeamContext } from "../../../context";
import { getUrlTokenExtracted } from "../../../context/helpers";
import { ArrowJumpingInStraightLine } from "../../atoms";
import {  SlotMachineHeader, SlotMachineNotification } from "../../molecules";
import { SlotMachineRefObject } from "../../molecules/SlotMachine/SlotMachineChosenCardHolder";
import SlotMachineChosenCardHolderDemoData from "./SlotMachineChosenCardHolderDemoData";
import SlotMachineSpinnerDemoData from "./SlotMachineSpinnerDemoData";

const SlotMachineDemoData : FC<{}> = () => {
    let slotMachineRef = useRef<SlotMachineRefObject>(null);
    const { teamNumber, game} = useContext(TeamContext);
    const { socket } = useContext(SocketContext);
    const { roomUsers } = useContext(TeamContext);
    const email = localStorage["userEmailInCaseHeLogsOut"];  

    const reconnect = () => {
        socket?.emit("reconnection", {email: email, matchId: getUrlTokenExtracted()});
        roomUsers();
    }

    useEffect( () => {
        roomUsers();
    }, [roomUsers])

    useEffect( () => {
        if(!game) {
            reconnect();
        }
    }, [game])

    return (
        <div>
            {teamNumber && 
            <div className="slot">
                <SlotMachineHeader isInDemoData = {true}/>        
                <SlotMachineNotification />
                <SlotMachineSpinnerDemoData slotMachineRef={slotMachineRef} />
                <SlotMachineChosenCardHolderDemoData ref={slotMachineRef} />
            </div>
            }
        </div>
    )

}

export default SlotMachineDemoData;